import { Task, ExpectedTaskAnswerMetadata } from "@jelly/lesson";

const items = [
  {
    id: "ae3de98e-16e3-488f-b49d-f28a2f86226a",
    content: "An average 35-year old woman can hear higher frequency<br>sound better than an average 35-year old man",
    options: {},
  },
  {
    id: "f8edd873-802f-4d11-9b4c-fbb9e3550bc1",
    content: "An average 65-year old woman can hear higher frequency<br>sound better than an average 35-year old man",
    options: {},
  },
  {
    id: "66003ba9-28c4-4dce-a4e0-45634a7e8ae6",
    content: "An average 40-year old man can hear lower frequency<br>sounds better than an average 35-year old man",
    options: {},
  },
  { id: "62c39c5e-ebb4-4fa7-9a3b-1fb77d28901c", content: "Men hear better than women in general", options: {} },
];

export const task: Task = {
  id: "8059cf3b-015b-49fd-ac30-8f56e4e49313",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["ae3de98e-16e3-488f-b49d-f28a2f86226a"],
};
